"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationWrapStyled = exports.StyledContent = exports.StyledHead = exports.ContainerStyled = exports.ComponentStyled = void 0;

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  max-width: 300px;\n  margin: 30px auto;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n\n    ", " {\n      padding-bottom: ", ";\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding-top: ", ";\n\n    ", " {\n      padding-top: ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ", "\n\n  &:before {\n    height: ", "px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: -1;\n    max-height: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 948px;\n  padding-left: 0;\n  padding-right: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ComponentStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject());
exports.ComponentStyled = ComponentStyled;
var ContainerStyled = (0, _uiKit.styled)(_container.Container)(_templateObject2());
exports.ContainerStyled = ContainerStyled;
var StyledHead = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, function (_ref2) {
  var $isCroppedTheme = _ref2.theme.$isCroppedTheme;
  return (0, _uiKit.css)(_templateObject4(), $isCroppedTheme ? 0 : '30px');
}, function (_ref3) {
  var removeTopPadding = _ref3.removeTopPadding;
  return (0, _uiKit.css)(_templateObject5(), removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeTopPadding ? 0 : '30px');
}, function (_ref4) {
  var $backDropHeight = _ref4.theme.$backDropHeight;
  return $backDropHeight || 0;
});
exports.StyledHead = StyledHead;
var StyledContent = (0, _uiKit.styled)(_uiKit.Box)(_templateObject6(), function (_ref5) {
  var removeBottomPadding = _ref5.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject7(), removeBottomPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px');
});
exports.StyledContent = StyledContent;
var NotificationWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject8());
exports.NotificationWrapStyled = NotificationWrapStyled;